/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getSupportArticle} from '../api'

 export const useQueryGetSupportArticle = createReactQueryHook('getSupportArticle', getSupportArticle)
